export default "__VITE_ASSET__BTWW4K00__"